export default "__VITE_ASSET__d840535a__"